// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"621":"eaac911a","704":"4be677ad","970":"4be677ad","994":"4be677ad"}[chunkId] + ".css";
};